import Sticky from './Sticky.vue';

export default Sticky;
